import { omitQueryKeys } from '@rhg/utils/routes';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

export const UpgradeDialogOpenQueryKey = 'udo';

export function useUpgradeDialog() {
    const { query, replace, pathname } = useRouter();

    const isUpgradeDialogOpen = query[UpgradeDialogOpenQueryKey] === 'true';

    const showUpgradeDialog = useCallback(
        (props?: { dropQueryKeys?: string[] }) => {
            const baseQuery = props?.dropQueryKeys
                ? omitQueryKeys(query, props.dropQueryKeys)
                : query;
            return replace(
                {
                    pathname,
                    query: {
                        ...baseQuery,
                        [UpgradeDialogOpenQueryKey]: 'true',
                    },
                },
                undefined,
                { shallow: true }
            );
        },
        [pathname, query, replace]
    );

    const closeUpgradeDialog = useCallback(async () => {
        if (!isUpgradeDialogOpen) {
            return;
        }
        const remainingQuery = Object.fromEntries(
            Object.entries(query).filter(
                ([key]) => key !== UpgradeDialogOpenQueryKey
            )
        );
        return replace({ pathname, query: remainingQuery }, undefined, {
            shallow: true,
        });
    }, [isUpgradeDialogOpen, pathname, query, replace]);

    return {
        isUpgradeDialogOpen,
        showUpgradeDialog,
        closeUpgradeDialog,
    };
}
